import {
  Flex,
  Box,
  Link,
  useColorModeValue,
  IconButton,
  HStack,
  useDisclosure,
  useColorMode,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon, MoonIcon, SunIcon } from "@chakra-ui/icons";
import { motion } from "framer-motion";
import { FaCommentDots, FaCode } from "react-icons/fa";

const Navbar = ({ sections, onSelect, onFeedbackClick }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const hoverColor = useColorModeValue("teal.500", "teal.200");
  const bgColor = useColorModeValue(
    "rgba(255, 255, 255, 0.8)",
    "rgba(26, 32, 44, 0.8)"
  );
  const boxShadowColor = useColorModeValue(
    "rgba(0, 0, 0, 0.1)",
    "rgba(0, 0, 0, 0.1)"
  );
  const iconColor = useColorModeValue("blue.500", "blue.300");

  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Box
      bg={bgColor}
      px={4}
      style={{ backdropFilter: "blur(10px)" }}
      position="fixed"
      width="100%"
      zIndex="10"
      boxShadow={`0 4px 6px ${boxShadowColor}`}
    >
      <Flex h={16} alignItems="center" justifyContent="space-between">
        <IconButton
          size="md"
          icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
          aria-label="Open Menu"
          display={{ md: "none" }}
          onClick={isOpen ? onClose : onOpen}
        />
        <HStack spacing={8} alignItems="center">
          <HStack spacing={2} alignItems="center">
            <FaCode color={iconColor} />
            <Box fontWeight="bold">Joabe Nascimento</Box>
          </HStack>
          <HStack
            as="nav"
            spacing={4}
            display={{ base: "none", md: "flex" }}
            fontWeight="bold"
          >
            {sections.map((section, index) => (
              <Box
                key={index}
                borderBottom="2px"
                borderColor="transparent"
                _hover={{ borderColor: hoverColor }}
                onClick={() => onSelect(section)}
              >
                <Link
                  as={motion.div}
                  whileHover={{ scale: 1.1 }}
                  cursor="pointer"
                  _hover={{
                    textDecoration: "none",
                    color: hoverColor,
                  }}
                >
                  {section}
                </Link>
              </Box>
            ))}
          </HStack>
        </HStack>
        <HStack spacing={4} alignItems="center">
          <IconButton
            as={motion.button}
            whileHover={{ scale: 1.1 }}
            icon={<FaCommentDots />}
            aria-label="Feedback"
            onClick={onFeedbackClick}
            _hover={{
              color: hoverColor,
            }}
          />
          <IconButton
            icon={colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            aria-label="Toggle Color Mode"
            onClick={toggleColorMode}
            _hover={{
              color: hoverColor,
            }}
          />
        </HStack>
      </Flex>

      {isOpen ? (
        <Box pb={4} display={{ md: "none" }}>
          <Flex direction="column" as="nav" spacing={4}>
            {sections.map((section, index) => (
              <Box
                key={index}
                borderBottom="2px"
                borderColor="transparent"
                _hover={{ borderColor: hoverColor }}
                onClick={() => onSelect(section)}
              >
                <Link
                  py={2}
                  _hover={{
                    textDecoration: "none",
                    color: hoverColor,
                  }}
                >
                  {section}
                </Link>
              </Box>
            ))}
          </Flex>
        </Box>
      ) : null}
    </Box>
  );
};

export default Navbar;
